const AITools: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🚀 Mau Belajar AI? Ini 4 Tools yang Bisa Kamu Coba Gratis</h2>

            <p className="mb-4">
                Ingin mulai belajar AI tapi bingung harus mulai dari mana? Jangan khawatir! Saat ini banyak tools gratis yang bisa membantumu belajar dan bereksperimen dengan AI, bahkan jika kamu belum punya pengalaman coding sekalipun. Berikut ini 4 tools yang direkomendasikan untuk pemula:
            </p>

            <ul className="list-disc list-inside space-y-3">
                <li>
                    <strong>🧪 Teachable Machine by Google</strong>
                    <p>Platform berbasis web ini sangat ramah bagi pemula. Kamu bisa membuat model AI yang mengenali gambar, suara, atau gerakan hanya dengan klik dan drag, tanpa perlu menulis kode. Cocok banget untuk eksperimen cepat dan belajar konsep dasar machine learning dengan cara yang menyenangkan.</p>
                </li>
                <li>
                    <strong>💻 Google Colab</strong>
                    <p>Google Colaboratory adalah notebook Python berbasis cloud yang memungkinkan kamu menulis dan menjalankan kode langsung di browser. Sudah tersedia akses GPU/TPU secara gratis, sangat cocok untuk latihan membuat model machine learning dengan pustaka seperti TensorFlow, PyTorch, atau Scikit-learn. Banyak tutorial online juga sudah disiapkan langsung di platform ini!</p>
                </li>
                <li>
                    <strong>📊 IBM Watson Studio</strong>
                    <p>Ini adalah platform profesional yang biasa digunakan oleh data scientist, tetapi punya versi gratis yang bisa kamu manfaatkan untuk belajar. Watson Studio menyediakan alat visual dan juga notebook Python, serta mendukung analisis data, pelatihan model AI, hingga pembuatan aplikasi AI secara end-to-end.</p>
                </li>
                <li>
                    <strong>🌍 Kaggle</strong>
                    <p>Merupakan komunitas dan platform pembelajaran data science terbesar di dunia. Di Kaggle, kamu bisa mengakses ribuan dataset, belajar melalui notebook yang dibagikan pengguna lain, serta mengikuti kompetisi data science untuk mengasah kemampuanmu. Selain itu, banyak kursus gratis yang bisa langsung kamu praktekkan di browser.</p>
                </li>
            </ul>

            <p className="mt-4">
                Coba eksplorasi salah satu (atau semuanya!) dan temukan gaya belajar yang paling cocok untukmu. Dunia AI sangat luas dan penuh peluang, yang penting adalah mulai dari langkah kecil, dan konsisten belajar setiap hari. Semangat belajar! 🚀
            </p>

        </div>)
}
export default AITools
